import { useParams } from 'react-router-dom';
import { Constrain } from '@/components/Constrain';
import { Card, CardInner } from '@/components/Card';
import { ClientForm } from '@/components/forms/ClientForm';
import { Text } from '@shared/components/ui/Text';
import { useClient } from '@/api/clients';
import { LoadingOverlay } from '@/components/LoadingOverlay';

/** Port of the `client/edit/:clientId` route (loader -> useClient). */
export function EditClientPage() {
    const { clientId } = useParams();
    const { data: client, isLoading, isError } = useClient(clientId);

    if (isError) throw new Error('Failed to fetch client from backend');
    if (isLoading) return <LoadingOverlay />;
    if (!client) throw new Error('Client not found');

    return (
        <Constrain width="narrow">
            <Card>
                <CardInner>
                    <Text as="h2" size="large" font="primary" weight="bold" color="uNavy">
                        Edit a client
                    </Text>
                </CardInner>
                <CardInner>
                    <ClientForm client={client} />
                </CardInner>
            </Card>
        </Constrain>
    );
}
